import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";
import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseFillMenuItemState } from "./BaseFillMenuItemState";
import { SiblingRelationship } from "shared/cubiq-services/lookup/model/impl/SiblingRelationshipManager";

export abstract class AbstractFillMenuItem extends BfxBlotterOrdersContextMenuItem {
  constructor(
    public actionId: BfxBlotterAction,
    title: string,
    checkAvailable: ContextMenuItemStateCommand<CubiqTS.OrderDataImpl>,
    checkEnabled: ContextMenuItemStateCommand<CubiqTS.OrderDataImpl>,
    public checkAvailableCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.MenuItem,
    public checkEnabledCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.Item,
  ) {
    super(
      actionId,
      title,
      checkAvailable,
      checkEnabled,
      checkAvailableCriteria,
      checkEnabledCriteria,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new BaseFillMenuItemState();
    this.state.title = oldState.title;
  }

  public static get state(): any {
    return new BaseFillMenuItemState();
  }

  public static isBothSidesOfGamma(
    item: CubiqTS.OrderDataImpl,
    itemState: BaseFillMenuItemState,
  ): boolean {
    let ret: boolean = false;
    // if orders from both sides of the same gamma are selected then quickfill should be diabled as per FXBFXOM-1318
    if (
      item.siblingRelationship != null &&
      item.siblingRelationship.relationshipType === CubiqTS.OrderRelationshipType.GAMMA
    ) {
      const gammaRelationship = item.siblingRelationship as SiblingRelationship;
      if (gammaRelationship) {
        itemState.relatedOrders[item.orderId.toString()] = item; // stash 'this' in case we go round
        const rungs: Array<CubiqTS.OrderDataImpl> = gammaRelationship.siblingOrders;
        for (let rung of rungs) {
          if (
            rung.orderId != item.orderId /* not me */ &&
            rung.orderState != CubiqTS.OrderState.GAMMA_MID_PENDING
          ) {
            /* not the mamma */ let alsoSelected = itemState.relatedOrders[rung.orderId.toString()];
            if (null != alsoSelected) {
              if (rung.trackingSide != item.trackingSide) {
                ret = true;
                break;
              }
            }
          }
        }
      }
    }
    return ret;
  }
}
